import Promise from 'bluebird';
import {Map, List} from 'immutable';
import {registry} from 'records';
import camelcase from 'camelcase';
import * as actionTypes from '../actionTypes';
import {DELETE, POST} from '../methods';
import {arrayize, camelCast, getOrSetArray} from '../utils';

export function parseJsonApiRepresentation(json) {
  const raw = json || {};
  const primaryData = arrayize(raw.data || []);
  const includedData = arrayize(raw.included || []);

  const representations = {};

  for (const datum of primaryData.concat(includedData)) {
    const Record = registry.find(datum.type);

    /* eslint-disable no-loop-func */
    const relationships = Map(Object.keys(datum.relationships || {})
      .map((relatedType) => {
        const related = datum.relationships[relatedType];

        if (!related.data) {
          return false;
        }

        let relatedValue = null;

        if (Array.isArray(related.data)) {
          relatedValue = List(related.data.map((i) => {
            return parseInt(i.id, 10);
          }));
        } else {
          relatedValue = parseInt(related.data.id, 10);
        }

        return [camelcase(relatedType), relatedValue];
      })
      .filter((item) => {
        return !!item;
      })).toObject();
    /* eslint-enable no-loop-func */

    const attributes = Object.assign({}, datum.attributes, relationships);
    const link = datum.links.self.split('/').slice(1);

    getOrSetArray(representations, datum.type)
      .push(new Record(camelCast(Object.assign({}, {id: datum.id, link}, attributes))));
  }

  return representations;
}

export function handle204(request, response) {
  return new Promise((resolve, reject) => {
    if (request.method === DELETE) {
      resolve({
        type: actionTypes.RESPONSE_DELETED,
        request,
        response,
      });
    }

    if (request.method === POST) {
      resolve({
        type: actionTypes.RESPONSE_NO_CONTENT,
        request,
        response,
      });
    }
  });
}

export function handle200(request, response) {
  return new Promise((resolve, reject) => {
    response.json()
      .then((json) => {
        const type = (request.method === POST) ? actionTypes.RESPONSE_CREATED : actionTypes.RESPONSE_DATA;

        resolve({
          type,
          request,
          response,
          data: parseJsonApiRepresentation(json),
        });
      })
      .catch((error) => {
        resolve({
          type: actionTypes.RESPONSE_NOT_JSON,
          request,
          response,
          error,
        });
      });
  });
}



// WEBPACK FOOTER //
// ./app/javascript/requests/responseHandlers/2xx.js